import { Component, Input } from '@angular/core';

@Component({
    selector: 'mobile-layout',
    templateUrl: './mobile-layout.component.html',
    styleUrls: ['./mobile-layout.component.scss']
})
export class MobileLayoutComponent {
    @Input() allowHome = true;

    public get showHome() {
    	if (!this.allowHome) return false;
    	return true;
    }
}
